import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// ============================================
// ENVIRONMENT-BASED LOGGING
// Disable console logs in all deployed environments
// Only localhost (local dev) will show logs
// ============================================
const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1';

if (!isLocalhost) {
  // Deployed environments: completely silent console — no logs, warnings,
  // errors, or MSAL output. Localhost keeps full logging for development.
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
  console.trace = noop;
  console.table = noop;
  console.dir = noop;
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
  console.assert = noop;

  // Suppress uncaught error and unhandled promise rejection stack traces
  window.onerror = () => true;
  window.addEventListener('unhandledrejection', (e) => e.preventDefault());
}

// Log environment configuration at startup
console.log('🌍 Application Starting');
console.log('📦 Build-time Environment:', environment.name);
console.log('🔗 API Base URL:', environment.apiBaseUrl);
console.log('🏢 B2C Tenant:', environment.b2c.tenant);

// Bootstrap the application
// MSAL redirect handling is done in app.ts ngOnInit
// Environment service will be initialized when first injected
bootstrapApplication(App, appConfig)
  .catch((err) => console.error('❌ Bootstrap error:', err));

